export const palettes = {
  Blue: {
    fill: ["#D8EEF8", "#7ABBDD", "#4596CB", "#316E97", "#204B65"],
    stroke: ["#47BEF4", "#1C90CD", "#196A9F", "#174C70", "#0F344B"],
  },
  Magenta: {
    fill: ["#E7D2DF", "#B7799F", "#8C2760", "#691D49", "#220817"],
    stroke: ["#BE6D9F", "#8F3F70", "#681042", "#4E0C32", "#190210"],
  },
  Orange: {
    fill: ["#F8EEE1", "#EBCAB2", "#D99867", "#D17E44", "#994C1D"],
    stroke: ["#EBAA55", "#E27E36", "#C06119", "#A75115", "#733007"],
  },
  Green: {
    fill: ["#CFE5D7", "#8CBF9C", "#6F918E", "#426D68", "#143732"],
    stroke: ["#6BBC89", "#479961", "#486563", "#284E49", "#0A2824"],
  },
  Gradient: {
    fill: ["#4288BF", "#476BA5", "#59528F", "#753775", "#8C2760"],
    stroke: ["#205E8E", "#274679", "#383167", "#551F55", "#681042"],
  },
  Mixed: {
    fill: ["#4596CB", "#8C2760", "#D99867", "#6F918E", "#59528F"],
    stroke: ["#196A9F", "#681042", "#C06119", "#486563", "#383167"],
  },
};
